import { Box, styled } from '@mui/material'
import { mobileScreenWidth } from 'utils'

export const styles = {
    peopleSearch: {
        '& > div': {
            border: 'solid 1px #ebebed',
            '&:hover': {
                borderColor: '#0057A0',
            },
            padding: '1.5px !important',
            '& > div': {
                right: '0px !important',
                pointerEvents: 'none',
            },
            '& > input': {
                height: '35px',
                cursor: 'pointer',
                width: 'auto !important',
            },
        },
    },
    cancelButton: {
        backgroundColor: '#ffffff !important',
        color: '#0057A0',
        boxShadow: 'none',
        border: '1px solid #0057A0',
    },
    checkIcon: {
        position: 'absolute',
        right: '10px',
    },
    listLabel: {
        position: 'absolute',
        top: '-24px',
        left: 5,
        fontSize: '10px',
        color: '#b4b4b4',
        fontWeight: 'bold',
    },
    skeleton: {
        margin: '10px 0px',
        width: '30%',
        borderRadius: '3px',
    },
}

export const ItemContainer = styled(Box)({
    padding: '15px 0px',
    [`@media (max-width:${mobileScreenWidth})`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
})

export const reducers = (state, { type, payload }) => {
    let newItems
    switch (type) {
        case 'SET_START_DATE':
            return { ...state, startDate: payload }

        case 'SET_END_DATE':
            return { ...state, endDate: payload }

        case 'SET_PEOPLE':
            return { ...state, people: payload }

        case 'SET_DELEGATE_FOREVER':
            return {
                ...state,
                endDate: null,
                activeOnlyIfOutOfOffice: false,
                delegateForever: payload,
            }
        case 'SET_OUT_OF_OFFICE':
            return {
                ...state,
                delegateForever: false,
                activeOnlyIfOutOfOffice: payload,
            }

        case 'CLEAR_STATE':
            return {
                ...payload,
            }

        case 'ADD_ITEMS':
            newItems = []
            //payload here is the items to add
            for (let i = 0; i < payload.length; i++) {
                const item = payload[i]
                const itemIndex = state.types.findIndex((i) => i.id === item.id)

                if (itemIndex === -1) {
                    newItems.push(item)
                }
            }

            return {
                ...state,
                types: [...state.types, ...newItems],
            }

        case 'REMOVE_ITEMS':
            newItems = [...state.types]

            for (let i = 0; i < payload.length; i++) {
                const item = payload[i]
                const itemIndex = newItems.findIndex((i) => i.id === item.id)

                if (itemIndex !== -1) {
                    newItems.splice(itemIndex, 1)
                }
            }

            return {
                ...state,
                types: newItems,
            }
        case 'REMOVE_ALL_ITEMS':
            return {
                ...state,
                types: payload,
            }
        default:
            return state
    }
}
